import * as types from '../types.js';

export default async function(records)
{
	return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: left; }
			.view td:nth-child(5)	{ text-align: center; }
			.view td:nth-child(6)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(7)	{ text-align: center; }
			.view td:nth-child(8)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(9)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(10)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(11)	{ text-align: left; }
			.view td:nth-child(12)	{ text-align: right; }
			.view td:nth-child(13)	{ text-align: right; }
			.view td:nth-child(14)	{ text-align: right; }
			.view td:nth-child(15)	{ text-align: left; max-width: 30rem; }
			.view td:nth-child(16)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(17)	{ text-align: left; max-width: 16rem; }
			.view td:nth-child(18)	{ text-align: center; }
			.view td:nth-child(19)	{ text-align: left; }
			.view td:nth-child(20)	{ text-align: left; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Pedido</th>
					<th data-index="3" data-visible="${this.visible[2]}">Referência</th>
					<th data-index="4" data-visible="${this.visible[3]}">Data Criação</th>
					<th data-index="5" data-visible="${this.visible[4]}">Criado Por</th>
					<th data-index="6" data-visible="${this.visible[5]}">Data Alteração</th>
					<th data-index="7" data-visible="${this.visible[6]}">Alterado Por</th>
					<th data-index="8" data-visible="${this.visible[7]}">Fornecedor&nbsp;/&nbsp;Cliente</th>
					<th data-index="9" data-visible="${this.visible[8]}">Transportador</th>
					<th data-index="10" data-visible="${this.visible[9]}">Programa</th>
					<th data-index="11" data-visible="${this.visible[10]}">Tipo Frete</th>
					<th data-index="12" data-visible="${this.visible[11]}">Valor Frete</th>
					<th data-index="13" data-visible="${this.visible[12]}">% Desconto</th>
					<th data-index="14" data-visible="${this.visible[13]}">Valor</th>
					<th data-index="15" data-visible="${this.visible[14]}">Observações</th>
					<th data-index="16" data-visible="${this.visible[15]}">Nº&nbsp;empenho</th>
					<th data-index="17" data-visible="${this.visible[16]}">Tipo&nbsp;recebimento</th>
					<th data-index="18" data-visible="${this.visible[17]}">Devolução</th>
					<th data-index="19" data-visible="${this.visible[18]}">Status</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async record => 
				`<tr data-id='${JSON.stringify([record.company_id, record.id])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([record.company_id, record.id]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick') || ''}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.reference || ''}</td>
					<td data-visible='${this.visible[3]}'>${this.format(types.datetime(), record.created_on)}</td>
					<td data-visible='${this.visible[4]}'>${await this.key('users', record.created_by)}</td>
					<td data-visible='${this.visible[5]}'>${this.format(types.datetime(), record.updated_on) || ''}</td>
					<td data-visible='${this.visible[6]}'>${await this.key('users', record.updated_by) || ''}</td>
					<td data-visible='${this.visible[7]}'>${await this.key(record.is_return ? 'customers' : 'suppliers', [record.company_id, record.is_return ? record.customer_id : record.supplier_id], 'nick') || ''}</td>
					<td data-visible='${this.visible[8]}'>${await this.key('carriers', [record.company_id, record.carrier_id], 'nick') || ''}</td>
					<td data-visible='${this.visible[9]}'>${await this.key('programs', record.program_id ? [record.company_id, record.program_id] : null, 'name') || ''}</td>
					<td data-visible='${this.visible[10]}'>${this.option(types.opt_freight_type(), record.freight_type) || ''}</td>
					<td data-visible='${this.visible[11]}'>${record.freight_value ? this.format(types.number(2), record.freight_value) : ''}</td>
					<td data-visible='${this.visible[12]}'>${record.discount ? this.format(types.number(2), record.discount) : ''}</td>
					<td data-visible='${this.visible[13]}'>${this.format(types.number(2), record.value)}</td>
					<td data-visible='${this.visible[14]}'>${record.notes || ''}</td>
					<td data-visible='${this.visible[15]}'>${record.empenho_number || ''}</td>
					<td data-visible='${this.visible[16]}'>${await (async () => { if (record.receipt_type_id == null || record.receipt_type_id === '') return ''; const k = [record.company_id, record.receipt_type_id]; const c = await this.key('receipt_types', k, 'code'); const d = await this.key('receipt_types', k, 'description'); return [c, d].filter(Boolean).join(' — '); })()}</td>
					<td data-visible='${this.visible[17]}'>${this.option(types.opt_bool(), record.is_return)}</td>
					<td data-visible='${this.visible[18]}'>${this.option(types.opt_input_order_status(), record.status) || ''}</td>
				</tr>`
				))).join('') +
			`
			</tbody>
		</table>
	`;
};

